/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'

class AddReason extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: ''
    }
  }
  componentDidMount() {}

  addReason() {
    var name = document.getElementById('name').value
    var type = document.getElementById('type').value
    var nameError = false
    var typeError = false
    var formError = false
    if (name == '') {
      formError = true
      nameError = true
      message.error('نام دلیل وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (type == '') {
      formError = true
      typeError = true
      message.error('نوع دلیل را وارد کنید')
    } else {
      if (!typeError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        name: name,
        type: type
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_ADD_REASON}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('دلیل جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/Reson')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/Reson'}>لیست دلایل</Link>
            </li>
            <li>ثبت دلیل</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت دلیل</p>
            </div>
            <div className="formComponent">
              <label>
                نام دلیل <span className="requireFiled">*</span>
              </label>
              <input type="text" id="name" className="form-control" />

              <label>
                نوع <span className="requireFiled">*</span>
              </label>
              <select className="form-control" name="type" id="type">
                <option value="">نوع را مشخص کنید</option>
                <option value="11">مرجوعی</option>
              </select>

              <button className="btn btn-info btn-block" onClick={this.addReason.bind(this)}>
                ثبت دلیل
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddReason
